"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.regexp.to-string.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("@citrus/button");
var _icon = require("@citrus/icon");
var _inputTextfield = require("@citrus/input-textfield");
var _inputCheckbox = require("@citrus/input-checkbox");
var _sortable = require("@citrus/sortable");
var _questionBuilder = require("@pcty/question-builder");
var _replaceAt = _interopRequireDefault(require("@pcty/utils-commonjs/array/replaceAt"));
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Constants");
var _PctyQuestionBuilder2 = require("./PctyQuestionBuilder.Common");
var _lodash = _interopRequireDefault(require("lodash.findindex"));
var _uuid = _interopRequireDefault(require("uuid"));
require("./index.css");
var _SortableStatic$Heade, _div, _Icon, _Icon2, _Icon3, _Icon4;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } //import '@citrus/layout/css/scaffolding-flex.css';
var PctyQuestionBuilderEditQuestionOptions = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctyQuestionBuilderEditQuestionOptions, _Component);
  var _super = _createSuper(PctyQuestionBuilderEditQuestionOptions);
  function PctyQuestionBuilderEditQuestionOptions(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctyQuestionBuilderEditQuestionOptions);
    _this = _super.call(this, props);
    // this is a check/flag that ensures our cleared on click only fires oncce.
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTempValues", function (_ref) {
      var option = _ref.option;
      // don't auto-clear upon focus for surveys
      if (_this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey) return;
      if (_this.state.multipleChoiceConfig.tempInputValues[option.id] !== 'cleared') {
        var tempInputValues = _objectSpread({}, _this.state.multipleChoiceConfig.tempInputValues);
        var multipleChoiceConfig = _objectSpread({}, _this.state.multipleChoiceConfig);
        tempInputValues[option.id] = 'cleared';
        multipleChoiceConfig.tempInputValues = tempInputValues;
        _this.setState({
          multipleChoiceConfig: multipleChoiceConfig
        });
      }
    });
    _this.state = {
      multipleChoiceConfig: {
        tempInputValues: {}
      }
    };
    _this.focus = {
      id: -1,
      position: 0
    };
    _this.onChangeRadio = _this.onChangeRadio.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeCheckbox = _this.onChangeCheckbox.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeOption = _this.onChangeOption.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickRemoveOption = _this.onClickRemoveOption.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickAddOption = _this.onClickAddOption.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickRemoveAllOptions = _this.onClickRemoveAllOptions.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeSortable = _this.onChangeSortable.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeOtherQuestion = _this.onChangeOtherQuestion.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeEnableOtherQuestion = _this.onChangeEnableOtherQuestion.bind((0, _assertThisInitialized2.default)(_this));
    _this.setTempValues = _this.setTempValues.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctyQuestionBuilderEditQuestionOptions, [{
    key: "onChangeRadio",
    value: function onChangeRadio(id) {
      var options = this.props.edit.options.map(function (x) {
        return _objectSpread(_objectSpread({}, x), {}, {
          selected: x.id === id
        });
      });
      var edit = _objectSpread(_objectSpread({}, this.props.edit), {}, {
        options: options,
        answers: [{
          optionId: id
        }]
      });
      this.props.onOptionsChange(edit);
    }
  }, {
    key: "onChangeCheckbox",
    value: function onChangeCheckbox(id) {
      var options = this.props.edit.options.map(function (x) {
        if (x.id === id) {
          return _objectSpread(_objectSpread({}, x), {}, {
            selected: !x.selected
          });
        }
        return x;
      });
      var edit = _objectSpread(_objectSpread({}, this.props.edit), {}, {
        options: options,
        answers: (0, _PctyQuestionBuilder2.getSelectedIds)(options)
      });
      this.props.onOptionsChange(edit);
    }
  }, {
    key: "onChangeSortable",
    value: function onChangeSortable(options) {
      var edit = _objectSpread(_objectSpread({}, this.props.edit), {}, {
        options: options
      });
      this.props.onOptionsChange(edit);
    }
  }, {
    key: "onChangeOtherQuestion",
    value: function onChangeOtherQuestion(_ref2) {
      var id = _ref2.id,
        value = _ref2.value;
      var edit = _objectSpread({}, this.props.edit);
      edit.otherQuestion.label = (0, _PctyQuestionBuilder2.decodeText)(value);
      this.props.onOptionsChange(edit);
    }
  }, {
    key: "onChangeEnableOtherQuestion",
    value: function onChangeEnableOtherQuestion(_ref3) {
      var id = _ref3.id,
        selected = _ref3.selected;
      var edit = _objectSpread({}, this.props.edit);
      edit.otherQuestion.enabled = selected;
      this.props.onOptionsChange(edit);
    }
  }, {
    key: "onChangeOption",
    value: function onChangeOption(_ref4) {
      var id = _ref4.id,
        value = _ref4.value;
      var _id = id.replace("".concat(this.props.id, "-text-"), '');
      var index = (0, _lodash.default)(this.props.edit.options, function (x) {
        return x.id === _id;
      });
      var correctOrderIndex = -1;
      var updated = _objectSpread(_objectSpread({}, this.props.edit.options[index]), {}, {
        value: (0, _PctyQuestionBuilder2.decodeText)(value)
      });
      if (this.props.builderType !== _PctyQuestionBuilder.BUILDER_TYPE.survey && this.props.edit.typeId === _questionBuilder.QUESTION_TYPE.stackRank) {
        correctOrderIndex = (0, _lodash.default)(this.props.edit.answers, function (x) {
          return x.id === _id;
        });
      }
      var edit = _objectSpread(_objectSpread({}, this.props.edit), {}, {
        options: (0, _replaceAt.default)(this.props.edit.options, index, updated)
      });
      if (correctOrderIndex >= 0) {
        edit = _objectSpread(_objectSpread({}, edit), {}, {
          answers: (0, _replaceAt.default)(this.props.edit.answers, correctOrderIndex, _objectSpread({}, updated))
        });
      }
      this.props.onOptionsChange(edit);
    }
  }, {
    key: "onClickRemoveOption",
    value: function onClickRemoveOption(id) {
      var options = this.props.edit.options.filter(function (x) {
        return x.id !== id;
      });
      var edit = null;
      if (this.props.edit.typeId === _questionBuilder.QUESTION_TYPE.checkbox) {
        edit = _objectSpread(_objectSpread({}, this.props.edit), {}, {
          options: options,
          answers: (0, _PctyQuestionBuilder2.getSelectedIds)(options)
        });
        var _validationState = (0, _PctyQuestionBuilder2.validate)(edit, this.props.validationState.showValidationState, this.props.builderType);
        this.props.onOptionsChange(edit, _validationState);
        return;
      }
      if (this.props.edit.typeId === _questionBuilder.QUESTION_TYPE.stackRank) {
        var answers = this.props.edit.answers ? this.props.edit.answers.filter(function (x) {
          return x.optionId !== id;
        }) : [];
        edit = _objectSpread(_objectSpread({}, this.props.edit), {}, {
          options: options,
          answers: answers
        });
        var _validationState2 = (0, _PctyQuestionBuilder2.validate)(edit, this.props.validationState.showValidationState, this.props.builderType);
        this.props.onOptionsChange(edit, _validationState2);
        return;
      }
      edit = _objectSpread(_objectSpread({}, this.props.edit), {}, {
        options: options,
        answers: (0, _PctyQuestionBuilder2.getSelectedIds)(options)
      });
      var validationState = (0, _PctyQuestionBuilder2.validate)(edit, this.props.validationState.showValidationState, this.props.builderType);
      this.props.onOptionsChange(edit, validationState);
    }
  }, {
    key: "onClickRemoveAllOptions",
    value: function onClickRemoveAllOptions() {
      var defaults = (0, _PctyQuestionBuilder2.getDefaultQuestionSettings)(this.props.edit.typeId, false, '');
      var options = (0, _toConsumableArray2.default)(defaults.options);
      var edit = _objectSpread(_objectSpread({}, this.props.edit), {}, {
        options: options,
        answers: []
      });
      var validationState = (0, _PctyQuestionBuilder2.validate)(edit, this.props.validationState.showValidationState, this.props.builderType);
      this.props.onOptionsChange(edit, validationState);
    }
  }, {
    key: "onClickAddOption",
    value: function onClickAddOption() {
      var newId = _uuid.default.v4();
      var newOptionValue = "Item ".concat(this.props.edit.options.length + 1);
      var edit = _objectSpread(_objectSpread({}, this.props.edit), {}, {
        options: [].concat((0, _toConsumableArray2.default)(this.props.edit.options), [{
          id: newId,
          value: newOptionValue
        }])
      });
      if (this.props.builderType !== _PctyQuestionBuilder.BUILDER_TYPE.survey && edit.typeId === _questionBuilder.QUESTION_TYPE.stackRank) {
        edit = _objectSpread(_objectSpread({}, edit), {}, {
          answers: [].concat((0, _toConsumableArray2.default)(edit.answers), [{
            optionId: newId
          }])
        });
      }
      this.props.onOptionsChange(edit);
    }
  }, {
    key: "renderInputType",
    value: function renderInputType(option) {
      var _this2 = this;
      switch (this.props.edit.typeId) {
        case _questionBuilder.QUESTION_TYPE.multipleChoice:
        case _questionBuilder.QUESTION_TYPE.trueFalse:
          return /*#__PURE__*/_react.default.createElement("input", {
            checked: option.selected,
            disabled: this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey,
            id: "".concat(this.props.id, "-").concat(option.id.toString(), "-radio"),
            name: this.props.edit.id + '-edit',
            onChange: function onChange() {
              return _this2.onChangeRadio(option.id);
            },
            type: "radio",
            value: option.value
          });
        case _questionBuilder.QUESTION_TYPE.checkbox:
          return /*#__PURE__*/_react.default.createElement("input", {
            checked: option.selected,
            disabled: this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey,
            id: "".concat(this.props.id, "-").concat(option.id.toString(), "-checkbox"),
            name: this.props.edit.id + '-edit',
            onChange: function onChange() {
              return _this2.onChangeCheckbox(option.id);
            },
            type: "checkbox",
            value: option.value
          });
        case _questionBuilder.QUESTION_TYPE.stackRank:
        default:
          return null;
      }
    }
  }, {
    key: "getSortableOptions",
    value: function getSortableOptions() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, this.getSortableOptionsContent()));
    }
  }, {
    key: "getSortableOptionsContent",
    value: function getSortableOptionsContent() {
      var _this3 = this;
      var showError = this.props.validationState && !this.props.validationState.answer.valid && this.props.validationState.showValidationState;
      var css = showError ? ' pcty-error' : '';

      // this seeds our option values with `Item X` values if they dont have any data provided.
      var seedOptions = function seedOptions() {
        var newEditOptions = (0, _toConsumableArray2.default)(_this3.props.edit.options);
        return newEditOptions;
      };

      //THIS BLOCK IS FOR ONLY THE TRUE-FALSE question!!
      if (this.props.edit.typeId === _questionBuilder.QUESTION_TYPE.trueFalse) {
        var selectCorrectAnswer = function selectCorrectAnswer() {
          return _this3.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey ? null : _SortableStatic$Heade || (_SortableStatic$Heade = /*#__PURE__*/_react.default.createElement(_sortable.SortableStatic.HeaderColumn, {
            align: "center"
          }, "Select Correct Answer"));
        };
        var renderOptionsHeader = function renderOptionsHeader() {
          return /*#__PURE__*/_react.default.createElement(_sortable.SortableStatic.HeaderRow, null, /*#__PURE__*/_react.default.createElement(_sortable.SortableStatic.HeaderColumn, null, _this3.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey ? 'Items' : 'Answers'), selectCorrectAnswer());
        };
        var renderOptionItem = function renderOptionItem(option) {
          if (_this3.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey) {
            return /*#__PURE__*/_react.default.createElement(_sortable.SortableStatic.Row, null, /*#__PURE__*/_react.default.createElement(_sortable.SortableStatic.Column, null, option.value));
          }
          return /*#__PURE__*/_react.default.createElement(_sortable.SortableStatic.Row, null, /*#__PURE__*/_react.default.createElement(_sortable.SortableStatic.Column, null, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-question-builder-option"
          }, option.value)), /*#__PURE__*/_react.default.createElement(_sortable.SortableStatic.Column, {
            align: "center"
          }, _this3.renderInputType(option)));
        };
        return /*#__PURE__*/_react.default.createElement("div", {
          className: 'pcty-input-wrapper' + css
        }, /*#__PURE__*/_react.default.createElement(_sortable.SortableStatic, {
          columnCount: this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey ? 1 : 2,
          data: this.props.edit.options,
          id: "".concat(this.props.id, "-").concat(this.props.edit.id, "-options"),
          renderHeader: renderOptionsHeader,
          renderItem: renderOptionItem
        }), showError ? /*#__PURE__*/_react.default.createElement("span", {
          className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
        }, this.props.validationState.answer.errorMessage) : '');
      }

      // THE REST OF THIS IS FOR ALL OTHER QUESTION TYPES!
      var ratingScaleLabel = function ratingScaleLabel() {
        return _this3.props.edit.typeId === _questionBuilder.QUESTION_TYPE.ratingScale ? _div || (_div = /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-margin-top pcty-margin-bottom pcty-border-bottom"
        }, /*#__PURE__*/_react.default.createElement("label", {
          className: "pcty-input-label"
        }, "Rating Scale ", /*#__PURE__*/_react.default.createElement("em", null, "(Required)")))) : null;
      };
      var renderHeader = function renderHeader() {
        var selectCorrectAnswer = function selectCorrectAnswer() {
          return _this3.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey || _this3.props.edit.typeId === _questionBuilder.QUESTION_TYPE.stackRank ? null : /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Column, {
            align: "center"
          }, "Select Correct Answer", _this3.props.edit.typeId === _questionBuilder.QUESTION_TYPE.checkbox ? '(s)' : '');
        };
        var ratingValue = function ratingValue() {
          return _this3.props.edit.typeId === _questionBuilder.QUESTION_TYPE.ratingScale ? /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Column, {
            align: "center",
            style: {
              width: '110px'
            }
          }, "Rating Value") : null;
        };
        var label = _this3.props.edit.typeId === _questionBuilder.QUESTION_TYPE.stackRank ? 'Answers and Display Order' : 'Answers';
        label = _this3.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey ? 'Items' : label;
        label = _this3.props.edit.typeId === _questionBuilder.QUESTION_TYPE.ratingScale ? 'Label' : label;
        return /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Row, null, ratingValue(), /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Column, null, label), selectCorrectAnswer());
      };
      var renderItem = function renderItem(option, index) {
        var _Sortable$Column;
        var placeHolderLabel = _this3.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey ? 'item' : 'answer';
        var ratingValue = function ratingValue() {
          return _this3.props.edit.typeId === _questionBuilder.QUESTION_TYPE.ratingScale ? _Sortable$Column || (_Sortable$Column = /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Column, {
            align: "center"
          }, index + 1)) : null;
        };
        if (_this3.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey || _this3.props.edit.typeId === _questionBuilder.QUESTION_TYPE.stackRank) {
          return /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Row, null, ratingValue(), /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Column, null, function () {
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "pcty-row-flex"
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "pcty-col pcty-padding-right-none"
            }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
              className: "pcty-question-builder-option-no-answer",
              clearOnFocus: !_this3.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey && !_this3.state.multipleChoiceConfig.tempInputValues[option.id],
              id: "".concat(_this3.props.id, "-text-").concat(option.id.toString()),
              maxLength: 1000,
              onChange: _this3.onChangeOption,
              onFocus: function onFocus() {
                return _this3.setTempValues({
                  option: option
                });
              },
              placeholder: "Please enter the text for your ".concat(placeHolderLabel, " here"),
              value: option.value
            })), /*#__PURE__*/_react.default.createElement("div", {
              className: "pcty-col-auto"
            }, /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
              id: "".concat(_this3.props.id, "-").concat(option.id.toString(), "-delete"),
              onClick: function onClick() {
                return _this3.onClickRemoveOption(option.id);
              }
            }, _Icon || (_Icon = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
              name: "delete",
              title: "Delete"
            })))));
          }()));
        }
        return /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Row, null, /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Column, null, function () {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-row-float-fill pcty-flex"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-fluid pcty-padding-right"
          }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
            className: "pcty-question-builder-option",
            clearOnFocus: !_this3.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey && !_this3.state.multipleChoiceConfig.tempInputValues[option.id],
            id: "".concat(_this3.props.id, "-text-").concat(option.id.toString()),
            maxLength: 1000,
            onChange: _this3.onChangeOption,
            onFocus: function onFocus() {
              return _this3.setTempValues({
                option: option
              });
            },
            placeholder: "Please enter the text for your answer here",
            value: option.value
          })), /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
            id: "".concat(_this3.props.id, "-").concat(option.id.toString(), "-delete"),
            onClick: function onClick() {
              return _this3.onClickRemoveOption(option.id);
            }
          }, _Icon2 || (_Icon2 = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
            name: "delete",
            title: "Delete"
          }))));
        }()), /*#__PURE__*/_react.default.createElement(_sortable.Sortable.Column, {
          align: "center"
        }, _this3.renderInputType(option)));
      };
      var maxItemsLimitReached = this.props.maximumItemCount && this.props.edit.options.length >= this.props.maximumItemCount ? true : false;
      return /*#__PURE__*/_react.default.createElement("div", null, ratingScaleLabel(), /*#__PURE__*/_react.default.createElement("div", {
        className: 'pcty-input-wrapper ' + css
      }, /*#__PURE__*/_react.default.createElement(_sortable.Sortable, {
        data: seedOptions(),
        id: "".concat(this.props.id, "-").concat(this.props.edit.id, "-options"),
        onChange: this.onChangeSortable,
        renderHeader: renderHeader,
        renderItem: renderItem
      }), showError ? /*#__PURE__*/_react.default.createElement("span", {
        className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
      }, this.props.validationState.answer.errorMessage) : ''), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12 pcty-padding-horizontal"
      }, /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
        css: {
          color: _button.styles.button.backgroundColor,
          ':hover': {
            color: '#ff9633'
          }
        },
        disabled: maxItemsLimitReached,
        id: "".concat(this.props.id, "-add-answer"),
        onClick: this.onClickAddOption,
        size: "small"
      }, _Icon3 || (_Icon3 = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
        name: "add",
        size: "xsmall",
        title: "Add"
      })), " ", this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey ? 'Add Item' : 'Add Answer'), /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
        css: {
          color: _button.styles.button.backgroundColor,
          ':hover': {
            color: '#ff9633'
          }
        },
        disabled: this.props.edit.options.length <= 0,
        id: "".concat(this.props.id, "-remove-all-answers"),
        onClick: this.onClickRemoveAllOptions,
        size: "small"
      }, _Icon4 || (_Icon4 = /*#__PURE__*/_react.default.createElement(_icon.Icon, {
        name: "delete",
        size: "xsmall",
        title: "Delete"
      })), " Reset Items"))));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.getSortableOptions(), this.getOtherItemBlock());
    }
  }, {
    key: "getOtherItemBlock",
    value: function getOtherItemBlock() {
      if (this.props.builderType === _PctyQuestionBuilder.BUILDER_TYPE.quiz) return null;
      if ([_questionBuilder.QUESTION_TYPE.checkbox, _questionBuilder.QUESTION_TYPE.multipleChoice, _questionBuilder.QUESTION_TYPE.dropdownList].indexOf(this.props.edit.typeId) <= -1) return null;
      if (!this.props.edit.otherQuestion) return null;
      var showError = this.props.validationState && !this.props.validationState.otherOption.valid && this.props.validationState.showValidationState;
      var css = showError ? ' pcty-error' : '';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-margin-top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'pcty-input-wrapper' + css
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "pcty-margin-bottom",
        style: {
          display: 'inline-flex'
        }
      }, /*#__PURE__*/_react.default.createElement(_inputCheckbox.Checkbox, {
        automationId: "single",
        id: "single",
        onChange: this.onChangeEnableOtherQuestion,
        selected: this.props.edit.otherQuestion.enabled
      }, "Include \"Other\" Response")), /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        className: "pcty-question-builder-option-no-answer",
        disabled: !this.props.edit.otherQuestion.enabled,
        id: "".concat(this.props.id, "-other-text"),
        maxLength: 500,
        onChange: this.onChangeOtherQuestion,
        placeholder: "Enter Other Response Label",
        value: this.props.edit.otherQuestion.label
      }), showError ? /*#__PURE__*/_react.default.createElement("span", {
        className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
      }, this.props.validationState.otherOption.errorMessage) : '')));
    }
  }]);
  return PctyQuestionBuilderEditQuestionOptions;
}(_react.Component);
PctyQuestionBuilderEditQuestionOptions.propTypes = {
  id: _propTypes.default.string.isRequired,
  builderType: _propTypes.default.oneOf([_PctyQuestionBuilder.BUILDER_TYPE.quiz, _PctyQuestionBuilder.BUILDER_TYPE.survey]),
  edit: _propTypes.default.object,
  onOptionsChange: _propTypes.default.func.isRequired,
  validationState: _propTypes.default.object.isRequired,
  maximumItemCount: _propTypes.default.number
};
PctyQuestionBuilderEditQuestionOptions.defaultProps = {
  maximumItemCount: 0
};
var _default = exports.default = PctyQuestionBuilderEditQuestionOptions;